export const TOOLBAR_BREAKPOINTS = [1350, 1150, 1000, 875, 650, 530] as const;

export const MAX_TIER = TOOLBAR_BREAKPOINTS.length;

/**
 * Returns the current toolbar tier (0..MAX_TIER) based on the viewport width.
 *
 * Tier N means the viewport is wide enough for the first N breakpoint thresholds.
 * Tier 0 = narrowest (most groups overflow), Tier MAX_TIER = widest (nothing overflows).
 */
export function getToolbarTier(width: number, breakpoints: readonly number[] = TOOLBAR_BREAKPOINTS): number {
    let tier = 0;
    for (const bp of breakpoints) {
        if (width >= bp) {
            tier++;
        }
    }
    return tier;
}
